const pageExists = (state, id) => state.guidebook.working.pageNodes.has(id);

export default pageExists;
